export const LABEL_ACTIVE = 'Active';
export const LABEL_INACTIVE = 'Not active';
